import {
	AfterViewChecked,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import * as $ from 'jquery';
import * as twix from 'twix';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { ListOfWorkflowGroup, WorkflowCalendarData } from '../../shared/interfaces/workflow';
import { AuthService } from '../../shared/services/auth.service';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import { TxApiService } from '../../shared/services/txapi.service';
import { CalendarService } from '../../shared/services/calendar.service';
import { WorkflowService } from '../../shared/services/workflow.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TabStateService } from '../../shared/services/tabstate.service';
import { TxEmployeeDocumentsDialogComponent } from '../dialogs/tx-employee-documents/tx-employee-documents.dialog.component';

declare let jQuery: any;
interface SpecialDay {
	datum: string;
	special_day: string;
	fehlzeit_name?: string;
	info?: string;
}

interface PersonColor {
	personalnr: number;
	text: string;
	color: string;
}

@Component({
	selector: 'tx-workflow-calendar',
	templateUrl: './tx-workflow-calendar.component.html',
	styleUrls: ['./tx-workflow-calendar.component.scss'],
})


export class TxWorkflowCalendarComponent implements OnInit, AfterViewChecked, OnDestroy {
	@Input() set CalendarData(value: any) {
		if (typeof this.myCalendarData !== 'undefined') {
			this.updateComponent(value);
		}
		if (value === null) {
			this.calendarReady = false;
			this.cachedWfCalendarData = [];
		} else {
			// Cache die ursprünglichen WfCalendar Daten
			this.cachedWfCalendarData = value ? JSON.parse(JSON.stringify(value)) : [];
		}
		this.myCalendarData = value;
	}

	get CalendarData(): any {
		return this.myCalendarData;
	}

	@Input()
	get WfGroups(): Array<ListOfWorkflowGroup> {
		return this._wfGroups;
	}
	set WfGroups(data: Array<ListOfWorkflowGroup>) {
		this._wfGroups = data;
		this.syncGroupStates();
	}

	constructor(
		private mySession: AuthService,
		private translate: TranslateService,
		private myTxApiService: TxApiService,
		private localStorageService: LocalStorageService,
		private calendarService: CalendarService,
		private deviceService: DeviceDetectorService,
		private workflowService: WorkflowService,
		public myTabStateService: TabStateService,
		private cdr: ChangeDetectorRef,
		private dialog: MatDialog
	) {
		if (this.deviceService.isMobile()){
			this.myTabStateService.onTabClose('f1');
		}

		this.currentPersoId = this.mySession.getSession().personalnr;
		this.defaultLocale = this.translate.currentLang;

		this.scrollDebounce$
			.asObservable()
			.pipe(
				debounceTime(200),
				map((scrollLeft: number) => {
					this.localStorageService.set('txWorkflowCalendarScrollLeft', scrollLeft);
				})
			)
			.subscribe();
	}

	get componentState() {
		if (this.WfGroups) {
			return this.componentChecks.data && this.componentChecks.storage && this.componentChecks.view;
		} else {
			return this.componentChecks.data && this.componentChecks.view;
		}
	}

	public SelectedGroups: number[] = [];
	private myCalendarData: any;

	@Input() showAllDataLoad = false;

	@Input() TeamLeader = false;
	private _wfGroups: ListOfWorkflowGroup[] = null;

	@Output() OnClickLoadFullYear: Subject<null> = new Subject<null>();
	@Output() OnBusy: Subject<boolean> = new Subject<boolean>();
	@Output() OnRefresh: Subject<null> = new Subject<null>();
	@Output() OnGroupFilterChange: Subject<null> = new Subject<null>();

	itemsPerPage = 10;
	myCalendarRange: WorkflowCalendarData = { days: [], daysInCurrentYear: [], month: [], years: [], persons: [] };
	theDefaultDayArray = [];
	myCalendarHasData = false;
	groupFilterTrigger = true;
	ngAfterViewCheckedDone = false;
	componentChecks = {
		data: false,
		view: false,
		storage: false,
	};
	calendarReady = false;
	currentPersoId: any;
	defaultLocale = 'de-DE';

	activeWfGroups: number[];

	private scrollDebounce$ = new Subject();
	private specialDays: SpecialDay[] = [];
	private specialDayCache: Map<string, boolean> = new Map();
	// Neue Maps zur Speicherung der Personenfarben und -texte
	private personColors: Map<number, string> = new Map();
	private personTexts: Map<number, string> = new Map();
	private destroy$ = new Subject<void>();
	private calendarUpdateSubscription: Subscription;
	private cachedWfCalendarData: any[] = []; // Cache für ursprüngliche getWfCalendar Daten

	openEmployeeDocuments(person: { personalnr?: number; name?: string }, event?: Event): void {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (!this.TeamLeader) {
			return;
		}

		const employeeId = Number(person?.personalnr ?? 0);
		if (!employeeId) {
			return;
		}

		this.dialog.open(TxEmployeeDocumentsDialogComponent, {
			width: '900px',
			maxWidth: '95vw',
			data: {
				employeeId,
				employeeName: person?.name,
				mode: 'teamleader',
			},
		});
	}

	checkCurrentUser(aPersonalnr: string): boolean {
		const myCurrentUser = JSON.parse(localStorage.getItem('currentSession'));
		return aPersonalnr === myCurrentUser.personalnr;
	}

	formatDate(days: any[]): string {
		return `${days[3]}-${days[2]}-${days[0]}`;
	}

	onTabOpen(name :string) {
		this.myTabStateService.onTabOpen(name);
	}

	onTabClose(name :string) {
		this.myTabStateService.onTabClose(name);
	}

	clearSpecialDayCache() {
		this.specialDayCache.clear();
	}

	isSpecialDay(dateStr: string): boolean {
		if (this.specialDayCache.has(dateStr)) {
			return this.specialDayCache.get(dateStr);
		}

		const formattedDate = moment(dateStr).format('YYYY-MM-DD');
		const result = this.specialDays.some(day =>
			moment(day.datum).format('YYYY-MM-DD') === formattedDate
		);

		this.specialDayCache.set(dateStr, result);
		return result;
	}

	getMaxHeight(): string {
		return `${38 * this.itemsPerPage}px`;
	}


	precalculateSpecialDays() {
		if (!this.myCalendarRange?.days) return;

		this.clearSpecialDayCache();
		this.myCalendarRange.days.forEach(days => {
			const dateStr = this.formatDate(days);
			this.isSpecialDay(dateStr);
		});
	}

	// Methode zum Abrufen der Personenfarben und -texte
	loadPersonColors() {
		if (!this.CalendarData || this.CalendarData.length === 0) return;

		const requestData = {
			sessionid: this.mySession.getSession().sessionid,
			team_leader: this.TeamLeader ? 1 : 0
		};

		this.myTxApiService.callAPI('getWfCalendarInfo', requestData).subscribe({
			next: (response: any) => {
				if (response && response.WfCalendarInfo && Array.isArray(response.WfCalendarInfo)) {
					// Zurücksetzen der Maps
					this.personColors.clear();
					this.personTexts.clear();

					// Befüllen der Maps mit den Personalnummern, Farben und Texten
					response.WfCalendarInfo.forEach((info: PersonColor) => {
						if (info.personalnr) {
							if (info.color) {
								this.personColors.set(info.personalnr, info.color);
							}
							if (info.text) {
								this.personTexts.set(info.personalnr, info.text);
							}
						}
					});
				}
			},
			error: (error) => {
				console.error('Fehler beim Laden der Personenfarben und -texte:', error);
			}
		});
	}

	// Methode zum Abrufen der Farbe für eine bestimmte Personalnummer
	getPersonColor(personalnr: string | number): string {
		const numPersonalNr = typeof personalnr === 'string' ? parseInt(personalnr, 10) : personalnr;
		return this.personColors.get(numPersonalNr) || '#a9a9a9'; // Standard-Grau, falls keine Farbe definiert ist
	}

	// Methode zum Abrufen des Textes für eine bestimmte Personalnummer
	getPersonText(personalnr: string | number): string {
		const numPersonalNr = typeof personalnr === 'string' ? parseInt(personalnr, 10) : personalnr;
		return this.personTexts.get(numPersonalNr) || ''; // Leerer String, falls kein Text definiert ist
	}

	// Get tooltip text combining status and info for a person
	getPersonTooltip(personalnr: string | number, personInfo: string): string {
		const statusText = this.getPersonText(personalnr);
		const infoText = personInfo ? this.stripHtml(personInfo) : '';
		
		if (statusText && infoText) {
			return `${statusText}\n${infoText}`;
		} else if (statusText) {
			return statusText;
		} else if (infoText) {
			return infoText;
		}
		return '';
	}

	// Helper method to strip HTML tags from info field
	private stripHtml(html: string): string {
		const tmp = document.createElement('DIV');
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || '';
	}

	loadSpecialDays() {
		if (!this.CalendarData || this.CalendarData.length === 0) return;

		const startDate = moment(this.CalendarData[0].begin_date).format('YYYY-MM-DDTHH:mm:ss');
		const endDate = moment(this.CalendarData[0].end_date).format('YYYY-MM-DDTHH:mm:ss');

		const schedulerDateRange = {
			von: startDate,
			bis: endDate,
			team_leader_for: 0
		};

		this.myTxApiService.callAPI('getCalendarHead', schedulerDateRange).pipe(
			map((response: any) => {
				if (response && response.ListOfCalendarHead) {
					return response.ListOfCalendarHead
						.filter(item => item.special_day !== null)
						.map(item => ({
							datum: item.datum,
							special_day: item.special_day,
							fehlzeit_name: item.fehlzeit_name,
							info: item.info
						}));
				}
				return [];
			})
		).subscribe({
			next: (specialDays) => {
				this.specialDays = specialDays;
				this.precalculateSpecialDays();
			},
			error: (error) => {
				console.error('Fehler beim Laden der speziellen Tage:', error);
				this.specialDays = []; // Setze auf leeres Array im Fehlerfall
			}
		});
	}

	isTeamLeader(): boolean {
		const myCurrentUser = JSON.parse(localStorage.getItem('currentSession'));
		return myCurrentUser.team_leader === 1;
	}

	/**
	 * Number of groups the filter currently lets through, for the header indicator.
	 *
	 * Counted from WfGroups and not from SelectedGroups on purpose: SelectedGroups is restored from
	 * localStorage and can still hold ids of groups that no longer exist, which would produce a
	 * nonsensical "5 / 4". Both numbers have to come from the same array.
	 */
	activeGroupCount(): number {
		return (this.WfGroups ?? []).filter((group) => group.active).length;
	}

	/**
	 * Switches every group on or off in one go.
	 *
	 * Deliberately not a loop over toggleChip: each of those calls rebuilds the whole calendar
	 * matrix, fires two API requests and holds a 500ms busy state. Clicking 40 groups away one by
	 * one therefore costs 40 rebuilds — this does the same work exactly once.
	 */
	setAllGroups(active: boolean): void {
		if (!this.WfGroups?.length) {
			return;
		}

		this.OnBusy.next(true);

		// Both representations have to be written: the chips read SelectedGroups, the groupFilter
		// pipe reads group.active. Updating only one of them makes the chips lie about the data.
		this.WfGroups.forEach((group) => (group.active = active));
		this.SelectedGroups = active ? this.WfGroups.map((group) => group.id) : [];

		this.activeWfGroups = [...this.SelectedGroups];
		this.localStorageService.set('txworkflowCalendarGroups', this.activeWfGroups);
		this.localStorageService.set('txWorkflowGroups', this.WfGroups);
		// Must be flipped, otherwise the teamleader chart keeps rendering its stale copy.
		this.groupFilterTrigger = !this.groupFilterTrigger;

		this.updateComponent(this.cachedWfCalendarData);
		this.OnGroupFilterChange.next(null);

		setTimeout(() => {
			this.OnBusy.next(false);
		}, 500);
	}

	toggleChip(groupId: number): void {
		this.OnBusy.next(true);
		
		// Check if the group is already selected
		const index = this.SelectedGroups.indexOf(groupId);
		const groupToChange = this.WfGroups.findIndex((data) => data.id === groupId);
		
		if (index === -1) {
			// If not selected, add it to the selected groups
			this.SelectedGroups.push(groupId);
			if (groupToChange !== -1) {
				this.WfGroups[groupToChange].active = true;
			}
		} else {
			// If already selected, remove it from the selected groups
			this.SelectedGroups.splice(index, 1);
			if (groupToChange !== -1) {
				this.WfGroups[groupToChange].active = false;
			}
		}

		// Update activeWfGroups and save to localstorage
		this.activeWfGroups = [...this.SelectedGroups];
		this.localStorageService.set('txworkflowCalendarGroups', this.activeWfGroups);
		this.localStorageService.set('txWorkflowGroups', this.WfGroups);
		this.groupFilterTrigger = !this.groupFilterTrigger;

		// Update component and notify subscribers
		this.updateComponent(this.cachedWfCalendarData);
		this.OnGroupFilterChange.next(null);

		setTimeout(() => {
			this.OnBusy.next(false);
		}, 500);
	}

	toggleGroup(event, id) {
		this.OnBusy.next(true);
		const groupToChange = this.WfGroups.findIndex((data) => data.id === id);
		this.WfGroups[groupToChange].active = !this.WfGroups[groupToChange].active;
		this.groupFilterTrigger = !this.groupFilterTrigger;
		this.localStorageService.set('txWorkflowGroups', this.WfGroups);
		
		// Emit event to notify parent components about group filter change
		this.OnGroupFilterChange.next(null);

		setTimeout(() => {
			this.OnBusy.next(false);
		}, 500);
	}

	syncGroupStates() {
		if (this._wfGroups === null || this._wfGroups === undefined) {
			return;
		}

		// Versuche, gespeicherte Gruppen zu laden
		const savedGroups = this.localStorageService.get('txWorkflowGroups');
		if (savedGroups) {
			// Wenn gespeicherte Gruppen existieren, synchronisiere mit den aktuellen
			this._wfGroups.forEach((group, index) => {
				const savedGroup = savedGroups.find(sg => sg.id === group.id);
				if (savedGroup) {
					group.active = savedGroup.active;
				}
			});
		} else {
			// Keine gespeicherten Gruppen, setze alle auf aktiv
			this._wfGroups.forEach(group => group.active = true);
		}

		// Extrahiere die aktiven Gruppen-IDs zur Verwendung in SelectedGroups
		this.activeWfGroups = this._wfGroups
			.filter(group => group.active)
			.map(group => group.id);

		// Sync SelectedGroups mit activeWfGroups
		this.SelectedGroups = [...this.activeWfGroups];

		// Speichere aktualisierten Zustand
		this.localStorageService.set('txworkflowCalendarGroups', this.activeWfGroups);
		this.componentChecks.storage = true;
	}

	createCalendarView() {
		let curEl;
		let daysInMonthWanted;

		this.componentChecks.data = true;
		if (this.CalendarData.length > 0) {
			this.myCalendarHasData = true;

			const myTwix = (moment as any).twix(
				new Date(this.CalendarData[0].begin_date),
				new Date(this.CalendarData[0].end_date)
			);
			const beginDate = moment(this.CalendarData[0].begin_date, 'YYYY-MM-DDTHH:mm:ss');

			moment.locale(this.defaultLocale.slice(0, 2));

			let itr = myTwix.iterate('years');
			while (itr.hasNext()) {
				this.myCalendarRange.years.push(itr.next().format('YYYY'));
			}

			this.myCalendarRange.years.forEach((dataEntry) => {
				const beginYearDate = String(beginDate.year());
				if (dataEntry === beginYearDate) {
					this.myCalendarRange.daysInCurrentYear.push([
						(moment as any).twix(beginDate, moment(beginDate.year() + '-12-31', 'YYYY-MM-DD')).count('days'),
						dataEntry,
					]);
				} else {
					const restOfNextYear =
						(moment as any)
							.twix(new Date(this.CalendarData[0].begin_date), new Date(this.CalendarData[0].end_date))
							.count('days') -
						(moment as any).twix(beginDate, moment(beginDate.year() + '-12-31', 'YYYY-MM-DD')).count('days');
					this.myCalendarRange.daysInCurrentYear.push([restOfNextYear, dataEntry]);
				}
			});

			itr = myTwix.iterate('month');
			while (itr.hasNext()) {
				curEl = itr.next();
				curEl.locale(this.defaultLocale);
				daysInMonthWanted = (moment(curEl) as any)
					.twix(moment(curEl).add(curEl.daysInMonth() - 1, 'days'))
					.intersection(myTwix)
					.count('days');

				this.myCalendarRange.month.push(Array(curEl.format('MMMM'), curEl.format('YYYY'), daysInMonthWanted));
			}

			itr = myTwix.iterate('days');

			while (itr.hasNext()) {
				curEl = itr.next();
				curEl.locale('this.defaultLocale');
				const today = moment(curEl).isSame(moment(), 'day');
				this.myCalendarRange.days.push(
					Array(curEl.format('DD'), curEl.format('dd'), curEl.format('MM'), curEl.format('YYYY'), today)
				);
			}

			for (const defaultDay of this.myCalendarRange.days) {
				const currentDate = defaultDay[3] + '-' + defaultDay[2] + '-' + defaultDay[0] + 'T00:00:00';
				if (moment(currentDate).isSame(moment(), 'day')) {
					if (moment(currentDate).isoWeekday() > 5) {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '#ddd',
							table_text: '',
							todayClass: 'today',
							isError: '',
						});
					} else {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '',
							table_text: '',
							todayClass: 'today',
							isError: '',
						});
					}
				} else {
					if (moment(currentDate).isoWeekday() > 5) {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '#ddd',
							table_text: '',
							todayClass: '',
							isError: '',
						});
					} else {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '',
							table_text: '',
							todayClass: '',
							isError: '',
						});
					}
				}
			}

			const teamForLocalStorage = [];

			for (const aPersonEntry of this.CalendarData) {
				const aPersonsCalendarData = this.theDefaultDayArray.slice();

				if (aPersonEntry.ListOfDateItem != null) {
					for (const dateitem of aPersonEntry.ListOfDateItem) {
						dateitem.fehlzeit_name = dateitem.fehlzeit_name ? this.decode(dateitem.fehlzeit_name) : '';
						const dateitemOffset = (moment(this.CalendarData[0].begin_date) as any)
							.twix(moment(dateitem.datum))
							.count('days');
						aPersonsCalendarData[dateitemOffset - 1] = dateitem;
					}
				}

				this.myCalendarRange.persons.push({
					personalnr: aPersonEntry.personalnr,
					name: aPersonEntry.name,
					info: aPersonEntry.info,
					data: aPersonsCalendarData,
					group: aPersonEntry.workflow_group,
				});

				teamForLocalStorage.push({
					personalnr: aPersonEntry.personalnr,
					name: aPersonEntry.name,
				});
			}
			localStorage.setItem('txTeam', JSON.stringify(teamForLocalStorage));
		}
		this.componentChecks.view = true;
	}

	trackByFn(index) {
		return index;
	}

	onScrollCalendar(event: Event) {
		if (event.target instanceof HTMLDivElement) {
			this.scrollDebounce$.next(event.target.scrollLeft);
		}
	}

	jumpToToday(force = false) {
		setTimeout(() => {
			const $scroller = jQuery('#calendardatatable');
			const $headerScroller = jQuery('#headerdaymonth');

			if (!$scroller.length) {
				console.error('Scroller element nicht gefunden');
				return;
			}

			if (force || !this.localStorageService.get('txWorkflowCalendarScrollLeft')) {
				const $todayElement = jQuery('th.today');

				if ($todayElement.length > 0) {
					const todayPosition = $todayElement.position();

					if (todayPosition && 'left' in todayPosition) {
						const targetScrollLeft = Math.max(0, todayPosition.left);

						$scroller.animate({ scrollLeft: targetScrollLeft }, 500);
						if ($headerScroller.length) {
							$headerScroller.animate({ scrollLeft: targetScrollLeft }, 500);
						}

						this.localStorageService.set('txWorkflowCalendarScrollLeft', targetScrollLeft);
					} else {
						console.error('Position des heutigen Tags konnte nicht ermittelt werden');
					}
				} else {
					console.error('Element für heutigen Tag nicht gefunden');
				}
			} else {
				const scrollLeft = this.localStorageService.get('txWorkflowCalendarScrollLeft');
				if (scrollLeft !== null && scrollLeft !== undefined) {
					$scroller.animate({ scrollLeft }, 500);
					if ($headerScroller.length) {
						$headerScroller.animate({ scrollLeft }, 500);
					}
				}
			}
		}, 100);
	}

	refresh() {
		if (this.OnRefresh) {
			this.OnRefresh.next(null);
		}
	}

	loadFullYear() {
		if (this.OnClickLoadFullYear) {
			this.OnClickLoadFullYear.next(null);
		}
	}

	decode(str) {
		const span = document.createElement('span');
		return str.replace(/&[#A-Za-z0-9]+;/gi, (match, dec) => {
			span.innerHTML = match;
			return span.innerText;
		});
	}

	ngAfterViewChecked() {
		if (!this.ngAfterViewCheckedDone && this.componentState) {
			this.ngAfterViewCheckedDone = true;
			const $tdToday = jQuery('.today');
			const $thToday = $tdToday.closest('table tr.days').find('th').eq($tdToday.index());

			$thToday.addClass('today');

			jQuery('.scrollable .table-overflow').scroll(() => {
				$('.pinned .table-overflow table').css('margin-top', -$('.scrollable .table-overflow').scrollTop());
				jQuery('.calendar-data').css('margin-left', -jQuery('.scrollable .table-overflow').scrollLeft());
			});
			if (!this.calendarReady) {
				setTimeout(() => {
					this.calendarReady = true;
					setTimeout(() => this.jumpToToday());
				}, 250);
			}
		}
	}

	persistItemsPerPage() {
		const localStorageSettingsKey = 'txWorkflowCalendarItemsPerPage' + (this.TeamLeader ? 'Teamleader' : '');
		this.localStorageService.set(localStorageSettingsKey, { itemPerPage: this.itemsPerPage});

		console.log(this.itemsPerPage)

	}

	ngOnInit() {
		this.syncGroupStates();
		this.createCalendarView();
		const localStorageSettingsKey = 'txWorkflowCalendarItemsPerPage' + (this.TeamLeader ? 'Teamleader' : '');
		const value = this.localStorageService.get(localStorageSettingsKey);
		if (value !== null) {
			this.itemsPerPage = value.itemPerPage;
		}

		// Laden der speziellen Tage und Personenfarben
		this.loadSpecialDays();
		this.loadPersonColors();

		// Subscribe to calendar update events
		this.calendarUpdateSubscription = this.calendarService.workflowCalendarUpdate$
			.pipe(takeUntil(this.destroy$))
			.subscribe(({startDate, endDate, teamLeaderFor}) => {
				this.handleCalendarUpdate(startDate, endDate, teamLeaderFor);
			});

		// Subscribe to general refresh events - keep original refresh for manual refreshes
		this.calendarService.refreshCalendar$
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				this.refresh();
			});
	}

	private handleCalendarUpdate(startDate: string, endDate: string, teamLeaderFor: number) {
		this.workflowService.getWorkflowCalendarUpdate(startDate, endDate, teamLeaderFor)
			.subscribe({
				next: (response) => {
					if (response && response.WfCalendar) {
						this.mergeCalendarUpdate(response.WfCalendar);
					}
				},
				error: (error) => {
					console.error('Error fetching calendar update:', error);
				}
			});
	}

	private mergeCalendarUpdate(updatedData: any[]) {
		if (!this.cachedWfCalendarData || !updatedData) {
			return;
		}

		// Erstelle eine Kopie der gecachten Daten
		const mergedData = JSON.parse(JSON.stringify(this.cachedWfCalendarData));

		updatedData.forEach(updatedPerson => {
			const existingPersonIndex = mergedData.findIndex(
				person => person.personalnr === updatedPerson.personalnr
			);

			if (existingPersonIndex !== -1) {
				const originalPerson = mergedData[existingPersonIndex];
				
				// Merge nur den spezifischen Zeitraum in ListOfDateItem
				const mergedListOfDateItem = this.mergeTimeRangeInListOfDateItem(
					originalPerson.ListOfDateItem || [], 
					updatedPerson.ListOfDateItem || [],
					updatedPerson.begin_date,
					updatedPerson.end_date
				);
				
				mergedData[existingPersonIndex] = {
					...originalPerson, // Behalte ursprüngliche Daten (name, etc.)
					// Behalte wichtige Original-Felder
					name: updatedPerson.name || originalPerson.name,
					personalnr: originalPerson.personalnr, // Nie überschreiben
					workflow_group: updatedPerson.workflow_group !== undefined ? updatedPerson.workflow_group : originalPerson.workflow_group,
					ListOfDateItem: mergedListOfDateItem // Verwende gemergte ListOfDateItem
				};
			}
		});

		// Aktualisiere die CalendarData und lade die Darstellung neu
		this.myCalendarData = mergedData;
		
		// Reset calendar range to force complete rebuild
		this.myCalendarRange = { days: [], daysInCurrentYear: [], month: [], years: [], persons: [] };
		this.theDefaultDayArray = [];
		this.componentChecks.data = false;
		this.componentChecks.view = false;
		
		// Force component update
		this.updateComponent(mergedData);
		
		// Force complete object recreation to trigger change detection
		this.myCalendarRange = { ...this.myCalendarRange };
		this.myCalendarRange.persons = [...this.myCalendarRange.persons];
		
		// Trigger CalendarData setter to force template update
		this.CalendarData = [...mergedData];
		
		// Force Angular change detection
		this.cdr.markForCheck();
		this.cdr.detectChanges();
		
		// Also trigger ngAfterViewChecked reset
		this.ngAfterViewCheckedDone = false;
	}

	private mergeTimeRangeInListOfDateItem(originalList: any[], updatedList: any[], startDate: string, endDate: string): any[] {
		// Kopiere die Original-Liste
		const mergedList = [...originalList];

		// Bestimme den Datumsbereich der geupdatet werden soll
		const startMoment = moment(startDate);
		const endMoment = moment(endDate);

		// Entferne alle Einträge aus dem Original die im Update-Zeitraum liegen
		const filteredList = mergedList.filter(item => {
			const itemDate = moment(item.datum);
			const isInRange = itemDate.isBetween(startMoment, endMoment, 'day', '[]');
			return !isInRange; // Behalte nur Einträge AUSSERHALB des Update-Zeitraums
		});

		// Füge die neuen Update-Daten hinzu
		return [...filteredList, ...updatedList];
	}

	private updateComponent(calendardata: any) {
		let curEl;
		let daysInMonthWanted;

		// Reset the default day array for fresh rebuild
		this.theDefaultDayArray = [];

		const updatedCalendar: WorkflowCalendarData = {
			days: [],
			daysInCurrentYear: [],
			month: [],
			years: [],
			persons: [],
		};

		this.componentChecks.data = true;
		if (calendardata.length > 0) {
			this.myCalendarHasData = true;

			const myTwix = moment.twix(moment(calendardata[0].begin_date), moment(calendardata[0].end_date));
			const beginDate = moment(calendardata[0].begin_date, 'YYYY-MM-DDTHH:mm:ss');

			let itr = myTwix.iterate('years');
			while (itr.hasNext()) {
				updatedCalendar.years.push(itr.next().format('YYYY'));
			}

			updatedCalendar.years.forEach((dataEntry) => {
				const beginYearDate = String(beginDate.year());
				if (dataEntry === beginYearDate) {
					updatedCalendar.daysInCurrentYear.push([
						(moment as any).twix(beginDate, moment(beginDate.year() + '-12-31', 'YYYY-MM-DD')).count('days'),
						dataEntry,
					]);
				} else {
					const restOfNextYear =
						(moment as any)
							.twix(new Date(calendardata[0].begin_date), new Date(calendardata[0].end_date))
							.count('days') -
						(moment as any).twix(beginDate, moment(beginDate.year() + '-12-31', 'YYYY-MM-DD')).count('days');
					updatedCalendar.daysInCurrentYear.push([restOfNextYear, dataEntry]);
				}
			});

			itr = myTwix.iterate('month');
			while (itr.hasNext()) {
				curEl = itr.next();
				daysInMonthWanted = (moment(curEl) as any)
					.twix(moment(curEl).add(curEl.daysInMonth() - 1, 'days'))
					.intersection(myTwix)
					.count('days');

				updatedCalendar.month.push(Array(curEl.format('MMMM'), curEl.format('YYYY'), daysInMonthWanted));
			}

			itr = myTwix.iterate('days');

			while (itr.hasNext()) {
				curEl = itr.next();
				const today = moment(curEl).isSame(moment(), 'day');
				updatedCalendar.days.push(
					Array(curEl.format('DD'), curEl.format('dd'), curEl.format('MM'), curEl.format('YYYY'), today)
				);
			}

			for (const defaultDay of updatedCalendar.days) {
				const currentDate = defaultDay[3] + '-' + defaultDay[2] + '-' + defaultDay[0] + 'T00:00:00';
				if (moment(currentDate).isSame(moment(), 'day')) {
					if (moment(currentDate).isoWeekday() > 5) {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '#ddd',
							table_text: '',
							todayClass: 'today',
							isError: '',
						});
					} else {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '',
							table_text: '',
							todayClass: 'today',
							isError: '',
						});
					}
				} else {
					if (moment(currentDate).isoWeekday() > 5) {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '#ddd',
							table_text: '',
							todayClass: '',
							isError: '',
						});
					} else {
						this.theDefaultDayArray.push({
							calendar_id: '',
							tmpOffset: '',
							datum: currentDate,
							fehlzeit_id: '',
							fehlzeit_name: '',
							fehlzeit_color: '',
							table_text: '',
							todayClass: '',
							isError: '',
						});
					}
				}
			}

			const teamForLocalStorage = [];

			for (const aPersonEntry of calendardata) {
				const aPersonsCalendarData = this.theDefaultDayArray.slice();

				if (aPersonEntry.ListOfDateItem != null) {
					for (const dateitem of aPersonEntry.ListOfDateItem) {
						dateitem.fehlzeit_name = dateitem.fehlzeit_name ? this.decode(dateitem.fehlzeit_name) : '';
						const dateitemOffset = (moment(calendardata[0].begin_date) as any)
							.twix(moment(dateitem.datum))
							.count('days');
						aPersonsCalendarData[dateitemOffset - 1] = dateitem;
					}
				}

				updatedCalendar.persons.push({
					personalnr: aPersonEntry.personalnr,
					name: aPersonEntry.name,
					info: aPersonEntry.info,
					data: aPersonsCalendarData,
					group: aPersonEntry.workflow_group,
				});

				teamForLocalStorage.push({
					personalnr: aPersonEntry.personalnr,
					name: aPersonEntry.name,
				});
			}
			localStorage.setItem('txTeam', JSON.stringify(teamForLocalStorage));
		}
		this.myCalendarRange = updatedCalendar;

		if (!this.calendarReady) {
			setTimeout(() => {
				this.calendarReady = true;
				setTimeout(() => this.jumpToToday());
			}, 250);
		}
		if (calendardata && calendardata.length > 0) {
			this.clearSpecialDayCache();
			this.loadSpecialDays();
			this.loadPersonColors(); // Auch die Personenfarben aktualisieren
		}
		
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		this.scrollDebounce$.unsubscribe();
		if (this.calendarUpdateSubscription) {
			this.calendarUpdateSubscription.unsubscribe();
		}
	}
}
